<template>
	<div style="background-color: #242424;">
		<div class="pageFooter">
			<div class="codeBox">
				<div style="display: flex;">
					<div class="appDownload" style="margin-right: 15px;">
						<div
							class="codeImage large"
							style="background-image: url('https://test.dzyxedu.com/homeImage/app%E4%B8%8B%E8%BD%BD%E4%BA%8C%E7%BB%B4%E7%A0%81.png'); background-position: center; background-repeat: no-repeat; background-size: 100%;"
						></div>
						<div class="codeText small">APP下载</div>
					</div>
					<div class="funsBox">
						<el-popover placement="top" width="115" trigger="hover">
							<div style="text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E5%AD%A6%E4%B9%A0%E8%A7%84%E5%88%92%E5%B8%88.jpg" fit="fill"></el-image>
								<div>领取新人礼包</div>
							</div>
							<div slot="reference" class="funcBtn">备考礼包</div>
						</el-popover>
						<div class="funcBtn" @click="goContact">加入我们</div>
						<el-popover placement="top" width="115" trigger="hover">
							<div style="text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E5%AD%A6%E4%B9%A0%E8%A7%84%E5%88%92%E5%B8%88.jpg" fit="fill"></el-image>
								<div>在线举报</div>
							</div>
							<div slot="reference" class="funcBtn">盗版举报</div>
						</el-popover>
					</div>
				</div>
				<div style="display: flex;">
					<div style="margin-right: 13px;">
						<div
							class="codeImage small"
							style="background-image: url('https://test.dzyxedu.com/homeImage/%E4%B8%81%E9%9C%87%E6%8A%A4%E7%90%86%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.png');  background-position: center; background-repeat: no-repeat; background-size: 100%;"
						></div>
						<div class="codeText small">丁震护理公众号</div>
					</div>
					<div style="margin-right: 13px;">
						<div
							class="codeImage small"
							style="background-image: url('https://test.dzyxedu.com/homeImage/%E6%9C%89%E8%B5%9E%E5%B0%8F%E7%A8%8B%E5%BA%8F%E4%BA%8C%E7%BB%B4%E7%A0%81.png');  background-position: center; background-repeat: no-repeat; background-size: 100%;"
						></div>
						<div class="codeText small">有赞小程序</div>
					</div>
					<div style="margin-right: 13px;">
						<div
							class="codeImage small"
							style="background-image: url('https://test.dzyxedu.com/homeImage/%E5%85%A8%E7%A8%8B%E7%AD%94%E7%96%91%E4%BA%8C%E7%BB%B4%E7%A0%81.png');  background-position: center; background-repeat: no-repeat; background-size: 100%;"
						></div>
						<div class="codeText small">专业答疑</div>
					</div>
					<div style="margin-right: 13px; padding-top: 5px;">
						<el-popover placement="top" width="115" trigger="hover">
							<div style="text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E6%8A%96%E9%9F%B3%E4%BA%8C%E7%BB%B4%E7%A0%811.png" fit="fill"></el-image>
								<div>抖音扫码查看</div>
							</div>
							<div slot="reference">
								<div
									class="codeImage small"
									style="background-color: unset; width: 50px; height: 50px; background-image: url('https://test.dzyxedu.com/homeImage/%E6%8A%96%E9%9F%B31.png');  background-position: center; background-repeat: no-repeat; background-size: 100%;"
								></div>
								<div class="codeText small">抖音</div>
							</div>
						</el-popover>
					</div>
					<div style="margin-right: 13px; padding-top: 5px;">
						<el-popover placement="top" width="115" trigger="hover">
							<div style="text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E5%B0%8F%E7%BA%A2%E4%B9%A6%E4%BA%8C%E7%BB%B4%E7%A0%811.png" fit="fill"></el-image>
								<div>小红书</div>
							</div>
							<div slot="reference">
								<div
									class="codeImage small"
									style="background-color: unset; width: 50px; height: 50px; background-image: url('https://test.dzyxedu.com/homeImage/%E5%B0%8F%E7%BA%A2%E4%B9%A6.png');  background-position: center; background-repeat: no-repeat; background-size: 100%;"
								></div>
								<div class="codeText small">小红书</div>
							</div>
						</el-popover>
					</div>
					<div style="margin-right: 13px; padding-top: 5px;">
						<el-popover placement="top" width="115" trigger="hover">
							<div style="text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E5%BF%AB%E6%89%8B%E4%BA%8C%E7%BB%B4%E7%A0%811.png" fit="fill"></el-image>
								<div>快手</div>
							</div>
							<div slot="reference">
								<div
									class="codeImage small"
									style="background-color: unset; width: 50px; height: 50px; background-image: url('https://test.dzyxedu.com/homeImage/%E5%BF%AB%E6%89%8B.png');  background-position: center; background-repeat: no-repeat; background-size: 100%;"
								></div>
								<div class="codeText small">快手</div>
							</div>
						</el-popover>
					</div>
					<div style="margin-right: 13px; padding-top: 5px;">
						<el-popover placement="top" width="115" trigger="hover">
							<div style="text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/B%E7%AB%99%E4%BA%8C%E7%BB%B4%E7%A0%811.png" fit="fill"></el-image>
								<div>哔哩哔哩</div>
							</div>
							<div slot="reference">
								<div
									class="codeImage small"
									style="background-color: unset; width: 50px; height: 50px; background-image: url('https://test.dzyxedu.com/homeImage/B%E7%AB%99.png');  background-position: center; background-repeat: no-repeat; background-size: 100%;"
								></div>
								<div class="codeText small">哔哩哔哩</div>
							</div>
						</el-popover>
					</div>
				</div>
			</div>
			<div class="friendshipLink">
				<span>友情链接：</span>
				<span class="linkItem" @click="jumpOpenUrl('https://www.21wecan.com/')">国家卫生健康委人才交流服务中心</span>
				<span class="linkItem" @click="jumpOpenUrl('https://www1.nmec.org.cn/')">国家医学考试网</span>
				<span class="linkItem" @click="jumpOpenUrl('http://www.cpta.com.cn/')">中国人事考试网</span>
			</div>
		</div>
		<div class="footerBottom">
			<div>
				Copyright © 2015 - 2026 北京丁丁颐和科技有限公司
			</div>
			<div>
				All Rights Reserved. 版权所有
			</div>
			<div><a style="color: white; text-decoration: none;" href="https://beian.miit.gov.cn/" target="_blank">京ICP备16004443号-2</a> 公网安备11010802021750号</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CustomFooter',
		data() {
			return {};
		},
		mounted() {},
		methods: {
			jumpOpenUrl(url) {
				window.open(url);
			},
			goContact() {
				this.$emit('changeHeaderTab', '/contact');
				window.scrollTo({
					top: 0, // 滚动到页面顶部
					behavior: 'smooth', // 平滑滚动
				});
			},
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pageFooter {
		margin: 0 auto;
		height: 180px;
		background-color: #242424;
		padding: 0 450px 4px 450px;
		padding-top: 28px;
		box-sizing: border-box;
	}

	.codeBox {
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
	}

	.appDownload {
		margin-right: 64px;
	}

	.codeImage {
		border-radius: 10px;
		background: rgba(255, 255, 255, 1);
		margin: 0 auto;
		transition: all linear 0.3s;
	}
	.codeImage.large {
		width: 100px;
		height: 100px;
	}
	.codeImage.small {
		width: 80px;
		height: 80px;
	}
	.codeImage.small:hover {
		transform: scale(1.1);
	}
	.codeText {
		font-size: 18px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 26.06px;
		color: rgba(255, 255, 255, 1);
		text-align: left;
		vertical-align: top;
	}
	.codeText.small {
		font-size: 12px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 24.75px;
		color: rgba(255, 255, 255, 1);
		text-align: center;
		vertical-align: top;
	}

	.funcBtn {
		width: 88px;
		height: 25px;
		opacity: 1;
		border-radius: 5px;
		background: rgba(51, 51, 51, 1);

		border: 0.3px solid rgba(163, 163, 163, 1);

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 1px 12px 1px 12px;
		cursor: pointer;
		left: 12px;
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
		line-height: 23.17px;
		color: rgba(255, 255, 255, 1);
		vertical-align: top;
		margin-bottom: 8px;
	}
	.funcBtn:hover {
		color: rgba(255, 158, 116, 1);
	}
	.friendshipLink {
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 20.27px;
		color: rgba(255, 255, 255, 0.5);
		vertical-align: top;
		text-align: center;
		cursor: pointer;
	}

	.linkItem {
		cursor: pointer;
		margin-right: 15px;
	}
	.linkItem:hover {
		color: rgba(255, 158, 116, 1);
	}
	.footerBottom {
		height: 25px;
		opacity: 1;
		background-color: black;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 340px;
		color: white;
		font-size: 12px;
		font-weight: 300;
	}
</style>



// WEBPACK FOOTER //
// src/components/CustomFooter.vue